import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useGetCamp } from '../api';
import { useAnalytics } from '../context/AnalyticsContext';
import { Camp } from '../utils/types';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CampContent from '../components/camps/CampContent';
import './CampPage.css';

const CampPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data: camp, isLoading, error } = useGetCamp(id);
  const { trackPageView } = useAnalytics();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (camp) {
      trackPageView(`/camp/${id}`, `Camp: ${camp.name}`);
    }
  }, [trackPageView, id, camp]);

  const handleSimilarCampClick = (clickedCamp: Camp) => {
    navigate(`/camp/${clickedCamp.id}`);
  };

  if (isLoading) {
    return (
      <div className="app">
        <Header />
        <main className="camp-page-main">
          <div className="camp-page-loading">Loading camp details...</div>
        </main>
        <Footer />
      </div>
    );
  }

  if (error || !camp) {
    return (
      <div className="app">
        <Header />
        <main className="camp-page-main">
          <div className="camp-page-error">
            <h2>Camp not found</h2>
            <p>Sorry, we couldn't find the camp you're looking for.</p>
            <button className="btn btn--primary btn--md" onClick={() => navigate('/search')}>
              Browse All Camps
            </button>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="app">
      <Header />

      <main className="camp-page-main">
        <div className="camp-page-container">
          <CampContent
            camp={camp}
            variant="page"
            onSimilarCampClick={handleSimilarCampClick}
            newsletterSignupEnabled={true}
            analyticsPrefix="camp_page"
          />
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default CampPage;
